var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPunchIn = function SvgPunchIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#punchIn_svg__a)",
    stroke: "#1A1E2C",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.945 20.962 5.43-5.43M7.187 20.962H2.945V16.72M2.946 3l5.431 5.432M2.946 7.243V3h4.242M20.885 20.956l-5.433-5.433M20.885 16.713v4.242h-4.243M20.862 3.023 15.43 8.455M16.62 3.023h4.242v4.243"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "punchIn_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgPunchIn;